var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -21 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 0H64C28.715 0 0 28.715 0 64v341.332c0 35.285 28.715 64 64 64h384c35.285 0 64-28.715 64-64V64c0-35.285-28.715-64-64-64zm0 0",
    fill: "#cfd8dc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 0h384c35.348 0 64 28.652 64 64v74.668H0V64C0 28.652 28.652 0 64 0zm0 0",
    fill: "#2196f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.332 181.332H352v53.336h-74.668zm0 0M160 181.332h74.668v53.336H160zm0 0M42.668 181.332h74.664v53.336H42.668zm0 0M42.668 277.332h74.664v53.336H42.668zm0 0M160 277.332h74.668v53.336H160zm0 0M160 373.332h74.668v53.336H160zm0 0M277.332 373.332H352v53.336h-74.668zm0 0M277.332 277.332H352v53.336h-74.668zm0 0M394.668 277.332h74.664v53.336h-74.664zm0 0M394.668 181.332h74.664v53.336h-74.664zm0 0M42.668 405.332v-32h74.664v53.336H64c-11.754 0-21.332-9.578-21.332-21.336zm0 0M448 426.668h-53.332v-53.336h74.664v32c0 11.758-9.578 21.336-21.332 21.336zm0 0"
  }))));
}

export default __webpack_public_path__ + "9f4c2ea9d0a55349b24e4c8d62b0c51a.svg";
export { SvgTable as ReactComponent };